module.exports = __webpack_public_path__ + "static/img/1_0005.631c7ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0005.jpg
// module id = JgrF
// module chunks = 0